const CLOUDINARY_DELIVERY_URL = "https://res.cloudinary.com/gonation";

module.exports = {
  CLOUDINARY_THUMB: `${CLOUDINARY_DELIVERY_URL}/w_150,c_fit`,
  CLOUDINARY_PROFILE: `${CLOUDINARY_DELIVERY_URL}/w_375,c_fit`,
  CLOUDINARY_SHARE: `${CLOUDINARY_DELIVERY_URL}/w_600,c_fit`,
  CLOUDINARY_PREVIEW: `${CLOUDINARY_DELIVERY_URL}/w_825,c_fit`,
  CLOUDINARY_FULL_1: `${CLOUDINARY_DELIVERY_URL}/w_1350,c_fit`,
  CLOUDINARY_FULL_2: `${CLOUDINARY_DELIVERY_URL}/w_2100,c_fit`,
  CLOUDINARY_PRESET:
    process.env.NODE_ENV === "production" ? "prod_preset" : "dev_preset"
};



// WEBPACK FOOTER //
// ./src/helpers/cloudinaryConstants.js